import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-departamentedit',
  templateUrl: './departamentedit.component.html',
  styleUrls: ['./departamentedit.component.css']
})
export class DepartamenteditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
